// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2N8Iv","title":"Images90_title__oWaW8","images":"Images90_images__Zgz1E"};